// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xt9Gc","icon":"styles_icon__218nb"};